import SleepDiaryChart, {
  LegendItem,
  PlotType,
} from "@/components/report/commons/SleepDiaryChart";
import { UserType } from "@/components/report/types";
import { KeyboardArrowRight } from "@mui/icons-material";
import { Button, Divider, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export interface ChartData {
  date: string;
  bedtime: string | null;
  arise_time: string | null;
  sleep_data: {
    from: string;
    to: string;
    type: PlotType;
  }[];
}
export interface DeviceMeasurementDataProps {
  chart_data: ChartData[];
  uuid: string | undefined;
  userType: UserType;
}
export default function DeviceMeasurementData({
  chart_data,
  uuid,
  userType,
}: DeviceMeasurementDataProps) {
  return (
    <>
      <Stack sx={{ mx: 6, gap: 4 }}>
        <Typography variant="subtitle1">デバイス測定データ</Typography>
        <Stack direction="row" justifyContent="end" sx={{ gap: 4 }}>
          <LegendItem
            imageName="image_report_how_to_view_graphs_light_off.svg"
            text="消灯"
          />
          <LegendItem
            imageName="image_report_how_to_view_graphs_wake_up.svg"
            text="起床"
          />
          <LegendItem
            imageName="image_report_how_to_view_graphs_sleep.svg"
            text="睡眠"
          />
          <LegendItem
            imageName="image_report_how_to_view_graphs_mid-awakening.svg"
            text="睡眠中の覚醒"
          />
        </Stack>
        <Stack sx={{ height: "300px" }}>
          <SleepDiaryChart
            data={chart_data.map((d) => ({
              date: d.date,
              bedtime: d.bedtime == null ? null : new Date(d.bedtime),
              ariseTime: d.arise_time == null ? null : new Date(d.arise_time),
              sleepData: d.sleep_data.map((d) => ({
                from: new Date(d.from),
                to: new Date(d.to),
                type: d.type as PlotType,
              })),
            }))}
          />
        </Stack>

        <Stack direction="row" justifyContent="end">
          <Button
            endIcon={<KeyboardArrowRight />}
            size="small"
            sx={{ color: "text.secondary" }}
            component={RouterLink}
            to={`/${userType}/report/${uuid}/measurement_details`}
          >
            測定データの詳細を見る
          </Button>
        </Stack>
        <Divider />
      </Stack>
    </>
  );
}
